module.exports = __webpack_public_path__ + "img/logo.b1da3b01.jpg";